// DO NOT EDIT THIS FILE
// This file has been generated by gen-api-models
// eslint-disable sonar/max-union-size
// eslint-disable sonarjs/no-identical-functions

import * as t from "io-ts";

import * as r from "@pagopa/ts-commons/lib/requests";

import { PaymentRequestsGetResponse } from "./PaymentRequestsGetResponse";

import { ProblemJson } from "./ProblemJson";

import { NodeProblemJson404 } from "./NodeProblemJson404";

import { NodeProblemJson409 } from "./NodeProblemJson409";

import { NodeProblemJson502 } from "./NodeProblemJson502";

import { PartyConfigurationFaultPaymentProblemJson } from "./PartyConfigurationFaultPaymentProblemJson";

import { NewTransactionRequest } from "./NewTransactionRequest";

import { NewTransactionResponse } from "./NewTransactionResponse";

import { PaymentMethodsRequest } from "./PaymentMethodsRequest";

import { PaymentMethodsResponse } from "./PaymentMethodsResponse";

import { CreateSessionResponse } from "./CreateSessionResponse";

/****************************************************************
 * getPaymentRequestInfoAuth
 */

// Request type definition
export type GetPaymentRequestInfoAuthT = r.IGetApiRequestType<
  { readonly bearerAuth: string; readonly rpt_id: string },
  "Authorization",
  never,
  | r.IResponseType<200, PaymentRequestsGetResponse, never>
  | r.IResponseType<400, ProblemJson, never>
  | r.IResponseType<401, undefined, never>
  | r.IResponseType<404, NodeProblemJson404, never>
  | r.IResponseType<409, NodeProblemJson409, never>
  | r.IResponseType<502, NodeProblemJson502, never>
  | r.IResponseType<503, PartyConfigurationFaultPaymentProblemJson, never>
>;

export const getPaymentRequestInfoAuthDefaultResponses = {
  200: PaymentRequestsGetResponse,
  400: ProblemJson,
  401: t.undefined,
  404: NodeProblemJson404,
  409: NodeProblemJson409,
  502: NodeProblemJson502,
  503: PartyConfigurationFaultPaymentProblemJson
};

export type GetPaymentRequestInfoAuthResponsesT<
  A0 = PaymentRequestsGetResponse,
  C0 = PaymentRequestsGetResponse,
  A1 = ProblemJson,
  C1 = ProblemJson,
  A2 = undefined,
  C2 = undefined,
  A3 = NodeProblemJson404,
  C3 = NodeProblemJson404,
  A4 = NodeProblemJson409,
  C4 = NodeProblemJson409,
  A5 = NodeProblemJson502,
  C5 = NodeProblemJson502,
  A6 = PartyConfigurationFaultPaymentProblemJson,
  C6 = PartyConfigurationFaultPaymentProblemJson
> = {
  200: t.Type<A0, C0>;
  400: t.Type<A1, C1>;
  401: t.Type<A2, C2>;
  404: t.Type<A3, C3>;
  409: t.Type<A4, C4>;
  502: t.Type<A5, C5>;
  503: t.Type<A6, C6>;
};

export function getPaymentRequestInfoAuthDecoder<
  A0 = PaymentRequestsGetResponse,
  C0 = PaymentRequestsGetResponse,
  A1 = ProblemJson,
  C1 = ProblemJson,
  A2 = undefined,
  C2 = undefined,
  A3 = NodeProblemJson404,
  C3 = NodeProblemJson404,
  A4 = NodeProblemJson409,
  C4 = NodeProblemJson409,
  A5 = NodeProblemJson502,
  C5 = NodeProblemJson502,
  A6 = PartyConfigurationFaultPaymentProblemJson,
  C6 = PartyConfigurationFaultPaymentProblemJson
>(
  overrideTypes:
    | Partial<
        GetPaymentRequestInfoAuthResponsesT<
          A0,
          C0,
          A1,
          C1,
          A2,
          C2,
          A3,
          C3,
          A4,
          C4,
          A5,
          C5,
          A6,
          C6
        >
      >
    | t.Type<A0, C0>
    | undefined = {}
): r.ResponseDecoder<
  | r.IResponseType<200, A0, never>
  | r.IResponseType<400, A1, never>
  | r.IResponseType<401, A2, never>
  | r.IResponseType<404, A3, never>
  | r.IResponseType<409, A4, never>
  | r.IResponseType<502, A5, never>
  | r.IResponseType<503, A6, never>
> {
  const isDecoder = (d: any): d is t.Type<A0, C0> =>
    typeof d["_A"] !== "undefined";

  const type = {
    ...((getPaymentRequestInfoAuthDefaultResponses as unknown) as GetPaymentRequestInfoAuthResponsesT<
      A0,
      C0,
      A1,
      C1,
      A2,
      C2,
      A3,
      C3,
      A4,
      C4,
      A5,
      C5,
      A6,
      C6
    >),
    ...(isDecoder(overrideTypes) ? { 200: overrideTypes } : overrideTypes)
  };

  const d200 = (type[200].name === "undefined"
    ? r.constantResponseDecoder<undefined, 200, never>(200, undefined)
    : r.ioResponseDecoder<
        200,
        typeof type[200]["_A"],
        typeof type[200]["_O"],
        never
      >(200, type[200])) as r.ResponseDecoder<r.IResponseType<200, A0, never>>;

  const d400 = (type[400].name === "undefined"
    ? r.constantResponseDecoder<undefined, 400, never>(400, undefined)
    : r.ioResponseDecoder<
        400,
        typeof type[400]["_A"],
        typeof type[400]["_O"],
        never
      >(400, type[400])) as r.ResponseDecoder<r.IResponseType<400, A1, never>>;

  const d401 = (type[401].name === "undefined"
    ? r.constantResponseDecoder<undefined, 401, never>(401, undefined)
    : r.ioResponseDecoder<
        401,
        typeof type[401]["_A"],
        typeof type[401]["_O"],
        never
      >(401, type[401])) as r.ResponseDecoder<r.IResponseType<401, A2, never>>;

  const d404 = (type[404].name === "undefined"
    ? r.constantResponseDecoder<undefined, 404, never>(404, undefined)
    : r.ioResponseDecoder<
        404,
        typeof type[404]["_A"],
        typeof type[404]["_O"],
        never
      >(404, type[404])) as r.ResponseDecoder<r.IResponseType<404, A3, never>>;

  const d409 = (type[409].name === "undefined"
    ? r.constantResponseDecoder<undefined, 409, never>(409, undefined)
    : r.ioResponseDecoder<
        409,
        typeof type[409]["_A"],
        typeof type[409]["_O"],
        never
      >(409, type[409])) as r.ResponseDecoder<r.IResponseType<409, A4, never>>;

  const d502 = (type[502].name === "undefined"
    ? r.constantResponseDecoder<undefined, 502, never>(502, undefined)
    : r.ioResponseDecoder<
        502,
        typeof type[502]["_A"],
        typeof type[502]["_O"],
        never
      >(502, type[502])) as r.ResponseDecoder<r.IResponseType<502, A5, never>>;

  const d503 = (type[503].name === "undefined"
    ? r.constantResponseDecoder<undefined, 503, never>(503, undefined)
    : r.ioResponseDecoder<
        503,
        typeof type[503]["_A"],
        typeof type[503]["_O"],
        never
      >(503, type[503])) as r.ResponseDecoder<r.IResponseType<503, A6, never>>;

  return r.composeResponseDecoders(
    r.composeResponseDecoders(
      r.composeResponseDecoders(
        r.composeResponseDecoders(
          r.composeResponseDecoders(
            r.composeResponseDecoders(d200, d400),
            d401
          ),
          d404
        ),
        d409
      ),
      d502
    ),
    d503
  );
}

// Decodes the success response with the type defined in the specs
export const getPaymentRequestInfoAuthDefaultDecoder = () =>
  getPaymentRequestInfoAuthDecoder();

/****************************************************************
 * newTransactionAuth
 */

// Request type definition
export type NewTransactionAuthT = r.IPostApiRequestType<
  {
    readonly bearerAuth: string;
    readonly "x-correlation-id": string;
    readonly "x-client-id-from-client": string;
    readonly "x-rpt-ids"?: string;
    readonly body: NewTransactionRequest | ReadableStream<Uint8Array> | Buffer;
  },
  "Content-Type" | "Authorization",
  never,
  | r.IResponseType<200, NewTransactionResponse, never>
  | r.IResponseType<400, ProblemJson, never>
  | r.IResponseType<401, undefined, never>
  | r.IResponseType<404, NodeProblemJson404, never>
  | r.IResponseType<409, NodeProblemJson409, never>
  | r.IResponseType<502, NodeProblemJson502, never>
  | r.IResponseType<503, PartyConfigurationFaultPaymentProblemJson, never>
>;

export const newTransactionAuthDefaultResponses = {
  200: NewTransactionResponse,
  400: ProblemJson,
  401: t.undefined,
  404: NodeProblemJson404,
  409: NodeProblemJson409,
  502: NodeProblemJson502,
  503: PartyConfigurationFaultPaymentProblemJson
};

export type NewTransactionAuthResponsesT<
  A0 = NewTransactionResponse,
  C0 = NewTransactionResponse,
  A1 = ProblemJson,
  C1 = ProblemJson,
  A2 = undefined,
  C2 = undefined,
  A3 = NodeProblemJson404,
  C3 = NodeProblemJson404,
  A4 = NodeProblemJson409,
  C4 = NodeProblemJson409,
  A5 = NodeProblemJson502,
  C5 = NodeProblemJson502,
  A6 = PartyConfigurationFaultPaymentProblemJson,
  C6 = PartyConfigurationFaultPaymentProblemJson
> = {
  200: t.Type<A0, C0>;
  400: t.Type<A1, C1>;
  401: t.Type<A2, C2>;
  404: t.Type<A3, C3>;
  409: t.Type<A4, C4>;
  502: t.Type<A5, C5>;
  503: t.Type<A6, C6>;
};

export function newTransactionAuthDecoder<
  A0 = NewTransactionResponse,
  C0 = NewTransactionResponse,
  A1 = ProblemJson,
  C1 = ProblemJson,
  A2 = undefined,
  C2 = undefined,
  A3 = NodeProblemJson404,
  C3 = NodeProblemJson404,
  A4 = NodeProblemJson409,
  C4 = NodeProblemJson409,
  A5 = NodeProblemJson502,
  C5 = NodeProblemJson502,
  A6 = PartyConfigurationFaultPaymentProblemJson,
  C6 = PartyConfigurationFaultPaymentProblemJson
>(
  overrideTypes:
    | Partial<
        NewTransactionAuthResponsesT<
          A0,
          C0,
          A1,
          C1,
          A2,
          C2,
          A3,
          C3,
          A4,
          C4,
          A5,
          C5,
          A6,
          C6
        >
      >
    | t.Type<A0, C0>
    | undefined = {}
): r.ResponseDecoder<
  | r.IResponseType<200, A0, never>
  | r.IResponseType<400, A1, never>
  | r.IResponseType<401, A2, never>
  | r.IResponseType<404, A3, never>
  | r.IResponseType<409, A4, never>
  | r.IResponseType<502, A5, never>
  | r.IResponseType<503, A6, never>
> {
  const isDecoder = (d: any): d is t.Type<A0, C0> =>
    typeof d["_A"] !== "undefined";

  const type = {
    ...((newTransactionAuthDefaultResponses as unknown) as NewTransactionAuthResponsesT<
      A0,
      C0,
      A1,
      C1,
      A2,
      C2,
      A3,
      C3,
      A4,
      C4,
      A5,
      C5,
      A6,
      C6
    >),
    ...(isDecoder(overrideTypes) ? { 200: overrideTypes } : overrideTypes)
  };

  const d200 = (type[200].name === "undefined"
    ? r.constantResponseDecoder<undefined, 200, never>(200, undefined)
    : r.ioResponseDecoder<
        200,
        typeof type[200]["_A"],
        typeof type[200]["_O"],
        never
      >(200, type[200])) as r.ResponseDecoder<r.IResponseType<200, A0, never>>;

  const d400 = (type[400].name === "undefined"
    ? r.constantResponseDecoder<undefined, 400, never>(400, undefined)
    : r.ioResponseDecoder<
        400,
        typeof type[400]["_A"],
        typeof type[400]["_O"],
        never
      >(400, type[400])) as r.ResponseDecoder<r.IResponseType<400, A1, never>>;

  const d401 = (type[401].name === "undefined"
    ? r.constantResponseDecoder<undefined, 401, never>(401, undefined)
    : r.ioResponseDecoder<
        401,
        typeof type[401]["_A"],
        typeof type[401]["_O"],
        never
      >(401, type[401])) as r.ResponseDecoder<r.IResponseType<401, A2, never>>;

  const d404 = (type[404].name === "undefined"
    ? r.constantResponseDecoder<undefined, 404, never>(404, undefined)
    : r.ioResponseDecoder<
        404,
        typeof type[404]["_A"],
        typeof type[404]["_O"],
        never
      >(404, type[404])) as r.ResponseDecoder<r.IResponseType<404, A3, never>>;

  const d409 = (type[409].name === "undefined"
    ? r.constantResponseDecoder<undefined, 409, never>(409, undefined)
    : r.ioResponseDecoder<
        409,
        typeof type[409]["_A"],
        typeof type[409]["_O"],
        never
      >(409, type[409])) as r.ResponseDecoder<r.IResponseType<409, A4, never>>;

  const d502 = (type[502].name === "undefined"
    ? r.constantResponseDecoder<undefined, 502, never>(502, undefined)
    : r.ioResponseDecoder<
        502,
        typeof type[502]["_A"],
        typeof type[502]["_O"],
        never
      >(502, type[502])) as r.ResponseDecoder<r.IResponseType<502, A5, never>>;

  const d503 = (type[503].name === "undefined"
    ? r.constantResponseDecoder<undefined, 503, never>(503, undefined)
    : r.ioResponseDecoder<
        503,
        typeof type[503]["_A"],
        typeof type[503]["_O"],
        never
      >(503, type[503])) as r.ResponseDecoder<r.IResponseType<503, A6, never>>;

  return r.composeResponseDecoders(
    r.composeResponseDecoders(
      r.composeResponseDecoders(
        r.composeResponseDecoders(
          r.composeResponseDecoders(
            r.composeResponseDecoders(d200, d400),
            d401
          ),
          d404
        ),
        d409
      ),
      d502
    ),
    d503
  );
}

// Decodes the success response with the type defined in the specs
export const newTransactionAuthDefaultDecoder = () =>
  newTransactionAuthDecoder();

/****************************************************************
 * getAllPaymentMethodsAuth
 */

// Request type definition
export type GetAllPaymentMethodsAuthT = r.IPostApiRequestType<
  {
    readonly bearerAuth: string;
    readonly "x-rpt-ids"?: string;
    readonly body: PaymentMethodsRequest | ReadableStream<Uint8Array> | Buffer;
  },
  "Content-Type" | "Authorization",
  never,
  | r.IResponseType<200, PaymentMethodsResponse, never>
  | r.IResponseType<400, ProblemJson, never>
  | r.IResponseType<401, ProblemJson, never>
  | r.IResponseType<500, ProblemJson, never>
>;

export const getAllPaymentMethodsAuthDefaultResponses = {
  200: PaymentMethodsResponse,
  400: ProblemJson,
  401: ProblemJson,
  500: ProblemJson
};

export type GetAllPaymentMethodsAuthResponsesT<
  A0 = PaymentMethodsResponse,
  C0 = PaymentMethodsResponse,
  A1 = ProblemJson,
  C1 = ProblemJson,
  A2 = ProblemJson,
  C2 = ProblemJson,
  A3 = ProblemJson,
  C3 = ProblemJson
> = {
  200: t.Type<A0, C0>;
  400: t.Type<A1, C1>;
  401: t.Type<A2, C2>;
  500: t.Type<A3, C3>;
};

export function getAllPaymentMethodsAuthDecoder<
  A0 = PaymentMethodsResponse,
  C0 = PaymentMethodsResponse,
  A1 = ProblemJson,
  C1 = ProblemJson,
  A2 = ProblemJson,
  C2 = ProblemJson,
  A3 = ProblemJson,
  C3 = ProblemJson
>(
  overrideTypes:
    | Partial<
        GetAllPaymentMethodsAuthResponsesT<A0, C0, A1, C1, A2, C2, A3, C3>
      >
    | t.Type<A0, C0>
    | undefined = {}
): r.ResponseDecoder<
  | r.IResponseType<200, A0, never>
  | r.IResponseType<400, A1, never>
  | r.IResponseType<401, A2, never>
  | r.IResponseType<500, A3, never>
> {
  const isDecoder = (d: any): d is t.Type<A0, C0> =>
    typeof d["_A"] !== "undefined";

  const type = {
    ...((getAllPaymentMethodsAuthDefaultResponses as unknown) as GetAllPaymentMethodsAuthResponsesT<
      A0,
      C0,
      A1,
      C1,
      A2,
      C2,
      A3,
      C3
    >),
    ...(isDecoder(overrideTypes) ? { 200: overrideTypes } : overrideTypes)
  };

  const d200 = (type[200].name === "undefined"
    ? r.constantResponseDecoder<undefined, 200, never>(200, undefined)
    : r.ioResponseDecoder<
        200,
        typeof type[200]["_A"],
        typeof type[200]["_O"],
        never
      >(200, type[200])) as r.ResponseDecoder<r.IResponseType<200, A0, never>>;

  const d400 = (type[400].name === "undefined"
    ? r.constantResponseDecoder<undefined, 400, never>(400, undefined)
    : r.ioResponseDecoder<
        400,
        typeof type[400]["_A"],
        typeof type[400]["_O"],
        never
      >(400, type[400])) as r.ResponseDecoder<r.IResponseType<400, A1, never>>;

  const d401 = (type[401].name === "undefined"
    ? r.constantResponseDecoder<undefined, 401, never>(401, undefined)
    : r.ioResponseDecoder<
        401,
        typeof type[401]["_A"],
        typeof type[401]["_O"],
        never
      >(401, type[401])) as r.ResponseDecoder<r.IResponseType<401, A2, never>>;

  const d500 = (type[500].name === "undefined"
    ? r.constantResponseDecoder<undefined, 500, never>(500, undefined)
    : r.ioResponseDecoder<
        500,
        typeof type[500]["_A"],
        typeof type[500]["_O"],
        never
      >(500, type[500])) as r.ResponseDecoder<r.IResponseType<500, A3, never>>;

  return r.composeResponseDecoders(
    r.composeResponseDecoders(r.composeResponseDecoders(d200, d400), d401),
    d500
  );
}

// Decodes the success response with the type defined in the specs
export const getAllPaymentMethodsAuthDefaultDecoder = () =>
  getAllPaymentMethodsAuthDecoder();

/****************************************************************
 * createSessionAuth
 */

// Request type definition
export type CreateSessionAuthT = r.IPostApiRequestType<
  {
    readonly bearerAuth: string;
    readonly id: string;
    readonly lang?: string;
    readonly "x-rpt-ids"?: string;
  },
  "Content-Type" | "Authorization",
  never,
  | r.IResponseType<200, CreateSessionResponse, never>
  | r.IResponseType<401, undefined, never>
  | r.IResponseType<404, ProblemJson, never>
  | r.IResponseType<502, ProblemJson, never>
>;

export const createSessionAuthDefaultResponses = {
  200: CreateSessionResponse,
  401: t.undefined,
  404: ProblemJson,
  502: ProblemJson
};

export type CreateSessionAuthResponsesT<
  A0 = CreateSessionResponse,
  C0 = CreateSessionResponse,
  A1 = undefined,
  C1 = undefined,
  A2 = ProblemJson,
  C2 = ProblemJson,
  A3 = ProblemJson,
  C3 = ProblemJson
> = {
  200: t.Type<A0, C0>;
  401: t.Type<A1, C1>;
  404: t.Type<A2, C2>;
  502: t.Type<A3, C3>;
};

export function createSessionAuthDecoder<
  A0 = CreateSessionResponse,
  C0 = CreateSessionResponse,
  A1 = undefined,
  C1 = undefined,
  A2 = ProblemJson,
  C2 = ProblemJson,
  A3 = ProblemJson,
  C3 = ProblemJson
>(
  overrideTypes:
    | Partial<CreateSessionAuthResponsesT<A0, C0, A1, C1, A2, C2, A3, C3>>
    | t.Type<A0, C0>
    | undefined = {}
): r.ResponseDecoder<
  | r.IResponseType<200, A0, never>
  | r.IResponseType<401, A1, never>
  | r.IResponseType<404, A2, never>
  | r.IResponseType<502, A3, never>
> {
  const isDecoder = (d: any): d is t.Type<A0, C0> =>
    typeof d["_A"] !== "undefined";

  const type = {
    ...((createSessionAuthDefaultResponses as unknown) as CreateSessionAuthResponsesT<
      A0,
      C0,
      A1,
      C1,
      A2,
      C2,
      A3,
      C3
    >),
    ...(isDecoder(overrideTypes) ? { 200: overrideTypes } : overrideTypes)
  };

  const d200 = (type[200].name === "undefined"
    ? r.constantResponseDecoder<undefined, 200, never>(200, undefined)
    : r.ioResponseDecoder<
        200,
        typeof type[200]["_A"],
        typeof type[200]["_O"],
        never
      >(200, type[200])) as r.ResponseDecoder<r.IResponseType<200, A0, never>>;

  const d401 = (type[401].name === "undefined"
    ? r.constantResponseDecoder<undefined, 401, never>(401, undefined)
    : r.ioResponseDecoder<
        401,
        typeof type[401]["_A"],
        typeof type[401]["_O"],
        never
      >(401, type[401])) as r.ResponseDecoder<r.IResponseType<401, A1, never>>;

  const d404 = (type[404].name === "undefined"
    ? r.constantResponseDecoder<undefined, 404, never>(404, undefined)
    : r.ioResponseDecoder<
        404,
        typeof type[404]["_A"],
        typeof type[404]["_O"],
        never
      >(404, type[404])) as r.ResponseDecoder<r.IResponseType<404, A2, never>>;

  const d502 = (type[502].name === "undefined"
    ? r.constantResponseDecoder<undefined, 502, never>(502, undefined)
    : r.ioResponseDecoder<
        502,
        typeof type[502]["_A"],
        typeof type[502]["_O"],
        never
      >(502, type[502])) as r.ResponseDecoder<r.IResponseType<502, A3, never>>;

  return r.composeResponseDecoders(
    r.composeResponseDecoders(r.composeResponseDecoders(d200, d401), d404),
    d502
  );
}

// Decodes the success response with the type defined in the specs
export const createSessionAuthDefaultDecoder = () => createSessionAuthDecoder();
